// ADA updated - prevent hiding header on page scroll if using keyboard
window.forceStickyHeaderForKeyboardNav = window.forceStickyHeaderForKeyboardNav || function() {
	const sectionHeader = document.querySelector('.f-section-header');
	if (sectionHeader) {
		sectionHeader.classList.add('site-header--sticky');
		sectionHeader.classList.remove('site-header--hidden');
	}

	const headerWrapper = document.querySelector('.site-header__wrapper');
	if (headerWrapper) {
		headerWrapper.classList.remove('no-show', 'slide-out');
		headerWrapper.classList.add('slide-in');
		const parent = headerWrapper.parentElement;
		parent && parent.classList.add('site-header--sticky');
	}

	document.body.classList.add('header-sticky--visible');
};

// ADA - show the original header at the top of the page when we move back to the top
// this allows the announcement bar to continue to show
window.restoreTopHeaderForKeyboardNav = window.restoreTopHeaderForKeyboardNav || function() {
	const sectionHeader = document.querySelector('.f-section-header');
	if (sectionHeader) {
		sectionHeader.classList.remove('site-header--hidden', 'site-header--sticky', 'site-header--animate');
	}

	const headerWrapper = document.querySelector('.site-header__wrapper');
	if (headerWrapper) {
		headerWrapper.classList.remove('slide-in', 'slide-out', 'no-show');
		const parent = headerWrapper.parentElement;
		parent && parent.classList.remove('site-header--sticky', 'keep-absolute');
	}

	const mainContent = document.querySelector('.site-main');
	mainContent && mainContent.classList.remove('extra-top-padding');

	document.body.classList.remove('header-sticky--visible', 'header-sticky--hidden');
};

// ADA - keep keyboard navigation header state synced with scroll position
// If we are NOT at the top, force sticky. If we are back at top, restore normal header.
window.syncKeyboardHeaderStateWithScroll = window.syncKeyboardHeaderStateWithScroll || function(scrollTopValue) {
	if (!window.__headerAutoHideTabUsed) return;
	const scrollTop = typeof scrollTopValue === 'number'
		? scrollTopValue
		: (window.pageYOffset || document.documentElement.scrollTop);
	if (scrollTop > 0) {
		window.__headerAutoHideDisabledByTab = true;
		window.forceStickyHeaderForKeyboardNav();
		return;
	}
	window.__headerAutoHideDisabledByTab = false;
	window.restoreTopHeaderForKeyboardNav();
};

// ADA - wrapper so existing calls can route through the keyboard/scroll sync logic
window.maybeDisableHeaderAutoHideOnTabScroll = window.maybeDisableHeaderAutoHideOnTabScroll || function(scrollTopValue) {
	window.syncKeyboardHeaderStateWithScroll(scrollTopValue);
};

// ADA - initialize keyboard tracking once
// on first tab key, start watching scroll and run an immediate sync for jump/focus moves
window.initHeaderScrollDisableOnTab = window.initHeaderScrollDisableOnTab || function() {
	if (window.__headerAutoHideDisableOnTabInitialized) return;
	window.__headerAutoHideDisableOnTabInitialized = true;
	window.__headerAutoHideTabUsed = window.__headerAutoHideTabUsed || false;
	window.__headerAutoHideDisabledByTab = window.__headerAutoHideDisabledByTab || false;
	window.addEventListener('keydown', (event) => {
		if (event.key === 'Tab') {
			window.__headerAutoHideTabUsed = true;
			if (!window.__headerAutoHideTabScrollWatcherAdded) {
				window.__headerAutoHideTabScrollWatcherAdded = true;
				// ADA - keep sticky/header state updated on each scroll once keyboard nav starts
				window.addEventListener('scroll', () => {
					window.syncKeyboardHeaderStateWithScroll();
				}, { passive: true });
			}
			// ADA - run now and next tick so tab-driven jumps are picked up immediately
			requestAnimationFrame(() => window.syncKeyboardHeaderStateWithScroll());
			setTimeout(() => window.syncKeyboardHeaderStateWithScroll(), 0);
		}
	}, { once: true });
};

window.initHeaderScrollDisableOnTab();

class StickyHeader extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		this.stickyEnabled = this.dataset.headerSticky === 'true'
		this.hideOnScroll = true
		this.header = document.querySelector('.f-section-header')
		if (this.stickyEnabled) this.initStickyHeader()
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this._hideHeaderOnScrollUp)
		window.removeEventListener('scroll', this.onScrollHandler)
	}

	initStickyHeader() {
		this.currentScrollTop = 0
		this.preventReveal = false

		this.onScrollHandler = this._onScroll.bind(this)
		this._hideHeaderOnScrollUp = () => this.preventReveal = true

		this.addEventListener('preventHeaderReveal', this._hideHeaderOnScrollUp)
		window.addEventListener('scroll', this.onScrollHandler, false)

		this.rectTop = this.header.offsetTop
		this.offset = this.header.offsetTop + this.header.clientHeight

		document.body.classList.add('header-sticky-enabled')
	}

	_onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop
		window.maybeDisableHeaderAutoHideOnTabScroll(scrollTop)
		if (window.__headerAutoHideDisabledByTab) {
			// ADA - if user tabs back to top, restore original header state/announcement bar
			if (scrollTop <= this.rectTop) {
				window.restoreTopHeaderForKeyboardNav();
			}
			// ADA - stop normal hide/reveal scroll logic while keyboard mode is active
			return
		}

		if (scrollTop > this.currentScrollTop && scrollTop > this.offset) {
			requestAnimationFrame(this._hide.bind(this))
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.offset) {
			if (!this.preventReveal) {
				requestAnimationFrame(this._reveal.bind(this))
			} else {
				window.clearTimeout(this.isScrolling)

				this.isScrolling = setTimeout(() => {
					this.preventReveal = false
				}, 66)

				requestAnimationFrame(this._hide.bind(this))
			}
		} else if (scrollTop <= this.rectTop) {
			requestAnimationFrame(this._reset.bind(this))
		}

		this.currentScrollTop = scrollTop
	}

	_hide() {
		this.header.classList.add('site-header--sticky'); 
		// this.header.classList.add('site-header--sticky', 'site-header--hidden')
		// document.body.classList.remove('header-sticky--visible')
		this._closeMenuDisclosure()
	}

	_reveal() {
		this.header.classList.add('site-header--sticky', 'site-header--animate')
		this.header.classList.remove('site-header--hidden')
		document.body.classList.add('header-sticky--visible')
	}

	_reset() {
		this.header.classList.remove('site-header--hidden', 'site-header--sticky', 'site-header--animate')
		document.body.classList.remove('header-sticky--hidden')
	}

	_closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
		this.disclosures.forEach(disclosure => disclosure.close());

		this.siteNav = this.siteNav || this.header.querySelector('site-nav');
		this.siteNav && this.siteNav.closeMegaDropdowns()
	}
}

customElements.define('sticky-header', StickyHeader)
